import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface Props {
  showOnlyRoadmapNodes: boolean;
  setShowOnlyRoadmapNodes: (value: boolean) => void;
}

export function ShowOnlyRoadmapNodesButton(props: Readonly<Props>) {
  const { t } = useTranslation();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.setShowOnlyRoadmapNodes(e.target.checked);
  };

  return (
    <label
      style={{
        position: 'absolute',
        bottom: '10px',
        left: '10px',
        zIndex: 1000,
        background: 'white',
        border: '2px solid rgba(0,0,0,0.2)',
        cursor: 'pointer',
        borderRadius: '4px',
        padding: '6px 8px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
      }}>
      <Form.Check
        type="checkbox"
        className="action-checkbox me-2 "
        checked={props.showOnlyRoadmapNodes}
        onChange={handleChange}
      />
      <p className={'text-basic'}>{t('map.show-only-roadmap-nodes-button')}</p>
    </label>
  );
}
